/*
 * Copyright (C) 2020 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { styled } from '@material-ui/core';

import { Breakpoints } from 'utils/enums';

const FooterMobile = styled('nav')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(5, 0, 7),
  width: '100%',

  [theme.breakpoints.up(Breakpoints.Md)]: {
    display: 'none',
  },
}));

export { FooterMobile };
